import { commonEnv } from "./common";

export const commonProd = {
  production: true,
  trackActions: true,
  debug: false,
  ...commonEnv,
  pngDownload: 'https://png.globalwater.online',
  pdfGeneration: 'https://pdf.globalwater.online',
  geotiffDownload:'https://tif.globalwater.online',
  highQualityGeoJSONs: '/geojson',
  cookiePermissions: true,
  downloadService:'/download'
};
